<template>
  <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
     <div class="carousel-inner">

      <div class="carousel-item" v-for="(carousel_item, index) in carousel_array" v-bind:key="index" :class="{ 'active' : index === 0 }">
        <img :src="carousel_item.image" class="d-block w-100" :alt="carousel_item.button_txt">
        <div class="mx-auto my-2" style="width: 200px;">
          <a :href="carousel_item.button_url" class="btn d-inline-block me-1 btn-csub-gold hvr-icon-forward">{{ carousel_item.button_txt }}</a>
        </div>
      </div><br clear="all" />

    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    root: String
  },
  data () {
    return {
      carousel_array: []
    }
  },

  async created () {
    const { data: jsonData } = await axios.get(this.root + '/library/static/data/carousel.json?nocache' + (new Date()).getTime())
    this.carousel_array = jsonData.events
  }
}
</script>

<style scoped>

</style>
